import { z } from 'zod';
export const GetSelfSmsUserHeadersSchema = z.object({
    requestActor: z.string().optional(),
});
export const GetSelfSmsUserRequestSchema = GetSelfSmsUserHeadersSchema;
export const GetSelfSmsUserResponseSchema = z.object({
    hasSmsConnection: z.boolean(),
    phoneNumber: z.string().optional(),
});
export const GetSelfSmsUserApiSchema = {
    headers: GetSelfSmsUserHeadersSchema,
    response: GetSelfSmsUserResponseSchema,
};
